module.exports = __webpack_public_path__ + "static/media/TP.a04b9d55.svg";